import apolloClient, {
  createReadOnlyToken,
  READ_ONLY_TOKEN_SOURCE,
} from '../../Apollo/ApolloClient'
import type { TokenStrategy } from './TokenStrategy'

/**
 * Strategy for creating read-only tokens
 */
export const readOnlyTokenStrategy: TokenStrategy = {
  createToken: async (context) => {
    await createReadOnlyToken(context.apiUrl, READ_ONLY_TOKEN_SOURCE)
  },
  apolloClient,
  retryMetricName: 'strata.createReadOnlyToken.retries',
  errorMetricName: 'strata.createReadOnlyToken.error',
  modeName: 'readOnly',
}
